import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFilterList = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 11,
	height: 7,
	viewBox: "0 0 11 7",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M4.07123 6.97925H6.39764V5.81604H4.07123V6.97925ZM0 0V1.16321H10.4689V0H0ZM1.74481 4.07123H8.72406V2.90802H1.74481V4.07123Z",
		fill: "currentColor"
	})
});
export default SvgFilterList;
